import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Layout from "components/sales/layout/layout";
import ProductsListView from "components/brandActivation/viewDetails/productList/productList"
import localization from "assets/localization/localization";
import Notfound from "pages/notfound";
import ReactPaginate from "react-paginate";

const ProductsList = ({
  viewProducts = null,
  getProducts,
}) => {
  const [dataList, setDataList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isRender, setIsRender] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const res = await getProducts();
      setIsLoading(false);
      setCurrentPage(1);
      if (res === false) {
        setIsRender(true);
      }
      else setIsRender(false);
    })();
  }, [getProducts]);

  useEffect(() => {
    if (viewProducts !== null && viewProducts?.resultSets) {
      setDataList(viewProducts.resultSets);
      setPageCount(Math.ceil(viewProducts.total / viewProducts.per_page));
    }
    else setIsRender(false);
  }, [viewProducts]);

  const onPageChange = async (val) => {
    setIsLoading(true);
    const res = await getProducts(val.selected + 1);
    setIsLoading(false);
    if (res === false) {
      setIsRender(true);
    }
    else setIsRender(false);
  };

  return isRender ? (
    <Notfound />
  ) : (
    <Layout title={localization.products} isLoading={isLoading} pagination>
        <ProductsListView data={dataList} />
        {pageCount > 0 && (
          <div className="panel-pagination-col panel-table-pagination">
            <ReactPaginate
              previousLabel={"<"}
              nextLabel={">"}
              breakLabel={"..."}
              breakClassName={"break-me"}
              pageCount={pageCount}
              forcePage={currentPage - 1}
              pageRangeDisplayed={5}
              onPageChange={onPageChange}
              activeClassName={"active"}
            />
          </div>
        )}
    </Layout>
  );
};

ProductsList.propTypes = {
  viewProducts: PropTypes.object,
  getProducts: PropTypes.func,
  match: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
};

export default ProductsList;
